import store from "../../store";
export default [{
    path: "/team-leader/qualita/", name: "team-leader-qualita", component: () => import("./v2/TeamLeaderV2.vue"),
    meta: { menu: "team_leader", navigationMenu: "team_leader", hideSubMenu: true, teamLeaderView: "qualita", title: "Qualità", access: { inheritFrom: "page.team-leader" } },
    beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : "/login"),
}, {
    path: "/team-leader/reparto/", name: "team-leader-reparto", component: () => import("./v2/TeamLeaderV2.vue"),
    meta: { menu: "team_leader", navigationMenu: "team_leader", hideSubMenu: true, teamLeaderView: "reparto", title: "Reparti", access: { key: "page.team-leader", defaultGroups: ["Team leader", "Amministrazione", "Admin"] } },
    beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : "/login"),
}, {
    path: "/team-leader/miglioramenti/", name: "team-leader-miglioramenti", component: () => import("./v2/TeamLeaderV2.vue"),
    meta: { menu: "team_leader", navigationMenu: "team_leader", hideSubMenu: true, teamLeaderView: "miglioramenti", title: "Miglioramenti", access: { defaultGroups: ["Team leader", "Amministrazione", "Admin"] } },
    beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : "/login"),
}, {
    path: "/team-leader/azienda/", name: "team-leader-azienda", component: () => import("./v2/TeamLeaderV2.vue"),
    meta: { menu: "team_leader", navigationMenu: "team_leader", hideSubMenu: true, teamLeaderView: "azienda", title: "Azienda", access: { defaultGroups: ["Admin"], description: "Dati aziendali riservati ai superuser e al gruppo Admin, nel rispetto della regola di accesso." } },
    beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : "/login"),
}, {
    path: "/staff/team-leader-legacy/", name: "team-leader-legacy", component: () => import("./TeamLeaderLegacy.vue"),
    meta: { menu: "staff", navigationMenu: "team_leader", hideSubMenu: true, title: "Team leader precedente", access: { defaultGroups: ["Team leader", "Amministrazione"] } },
    beforeEnter: (to, from, next) => {
        if (!store.getters.isLoggedIn) return next("/login");
        if (store.getters.isCapabilityDefined("page.team-leader") && !store.getters.hasCapability("page.team-leader")) return next("/");
        next();
    },
}, {
    path: "/team-leader/", name: "team-leader",
    redirect: to => {
        if (to.query.progetto || to.query.vista === "board") return { name: "team-leader-legacy", query: to.query, hash: to.hash };
        const { vista, ...query } = to.query;
        return { name: `team-leader-${["azienda", "miglioramenti"].includes(vista) ? vista : "reparto"}`, query, hash: to.hash };
    },
}, {
    path: "/staff/team-leader/",
    redirect: to => ({ name: "team-leader", query: to.query, hash: to.hash }),
}];
